angular
	.module 'App.Repository'
	.factory 'ProductFilterRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class ProductFilterRepository extends BaseRepository
				@resource = '/product_filters'
				@isRestricted = true

				searchProductFilters: (searchString, existingProductFilters) ->
					query = @createQuery()
					criteria = query.criteria 'name', 'LIKE', searchString

					existingIds = _.pluck(existingProductFilters, 'product_filter_id')
					criteria.and 'id', 'NOT IN', existingIds.join()

					query.setPagination 0, 10

					return @findByQuery(query).then((result) -> result.data)

			return new ProductFilterRepository
]
